import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { deepMix } from '@antv/util';
import { LineXY } from '../shape';
import { MaybeTupleY } from '../transform';
import { baseAnnotationChannels, basePreInference, basePostInference, createBandOffset } from './utils';
var shape = {
  line: LineXY
};
export var LineY = function LineY(options) {
  return function (index, scale, value, coordinate) {
    var Y = value.y;
    var offset = createBandOffset(scale, value, deepMix({
      style: {
        bandOffset: 0
      }
    }, options));
    var P = Array.from(index, function (i) {
      var p1 = [0, Y[i]];
      var p2 = [1, Y[i]];
      return [p1, p2].map(function (d) {
        return coordinate.map(offset(d, i));
      });
    });
    return [index, P];
  };
};
LineY.props = {
  defaultShape: 'line',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseAnnotationChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'y',
    required: true
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeTupleY
  }]),
  postInference: _toConsumableArray(basePostInference())
};